export function toBigIntFromFloatString(value: string | bigint, decimals: number): bigint {
    if (typeof value === 'bigint') {
      return value;
    }
  
    const parts = value.split('.');
    const integerPart = parts[0] || '0';
    const decimalPart = (parts[1] || '').padEnd(decimals, '0').slice(0, decimals);
    return BigInt(integerPart + decimalPart);
  }